import { ActionPlanList } from './List'

export const ActionPlanScreen = ({ publicScreen }) => {
    return <ActionPlanList publicScreen={publicScreen} />
}

export * from './List'
